var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.486,
    height: 37.508,
    viewBox: "0 0 37.486 37.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play-bold",
    transform: "translate(-3.764 -3.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10551",
    "data-name": "Path 10551",
    d: "M4.875,24.281l8.456,4.238,5.981-5.981L13.275,16.5l-8.4,4.219A1.983,1.983,0,0,0,4.875,24.281Z",
    fill: "#fd792f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10552",
    "data-name": "Path 10552",
    d: "M13.275,16.5l6.037,6.038L37.443,4.406Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10553",
    "data-name": "Path 10553",
    d: "M19.313,22.538,37.275,40.5l1.069.544a2.008,2.008,0,0,0,2.906-1.8V5.756a2.008,2.008,0,0,0-2.906-1.8l-.9.45Z",
    fill: "#fd792f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10554",
    "data-name": "Path 10554",
    d: "M13.332,28.519,37.275,40.5,19.313,22.538Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBold);
export default __webpack_public_path__ + "static/media/play-bold.0e7944f20b20018db9980897f7fb0183.svg";
export { ForwardRef as ReactComponent };